import { subDays, subMonths, subYears, differenceInDays } from "date-fns";

export type CompareMode = "prev-month" | "prev-year" | "prev-period" | "none";

export function getComparisonRange(
  dateFrom: Date,
  dateTo: Date,
  mode: CompareMode
): { compareFrom: Date; compareTo: Date } | null {
  if (mode === "none") return null;

  if (mode === "prev-month") {
    return {
      compareFrom: subMonths(dateFrom, 1),
      compareTo: subMonths(dateTo, 1),
    };
  }

  if (mode === "prev-year") {
    return {
      compareFrom: subYears(dateFrom, 1),
      compareTo: subYears(dateTo, 1),
    };
  }

  // prev-period: same number of days, ending just before dateFrom
  const days = differenceInDays(dateTo, dateFrom);
  const compareTo = subDays(dateFrom, 1);
  const compareFrom = subDays(compareTo, days);
  return { compareFrom, compareTo };
}
